import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { setToken, getToken } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (!getToken()) {
      setUser(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setToken(null);
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const loginStaff = async (username, password) => {
    const { data } = await api.post("/auth/staff/login", { username, password });
    setToken(data.token);
    await refresh();
    return data.user;
  };

  const joinGuest = async (full_name, table_id = null) => {
    const { data } = await api.post("/auth/guest/join", { full_name, table_id });
    if (data.needs_disambiguation) return data;
    setToken(data.token);
    await refresh();
    return data.guest;
  };

  const logout = () => {
    setToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, loginStaff, joinGuest, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
